import { createDeletablePermission } from "@/permissions/shared/createDeletablePermission";
import { useActivitiesStore } from "@/stores/activitiesStore";

export function useActivitiesPermissions() {
  const store = useActivitiesStore();

  const deletable = createDeletablePermission(store);

  return { deletable };
}
